/*
 * jjs-search-events.js  (Joe 14.10.26)
 * First-party search behaviour capture for the self-learning search loop. Sends to the same JJ Data endpoint, with the
 * same visitor id (_shopify_y), as jjs-cart-tracker, so a search can be joined to add-to-bag and purchase.
 *
 *   search_used   a visitor typed a search (3+ characters, debounced). Fires for BOTH arms of the ts-search test, so the
 *                 test can be read on "sessions that used search" and not only on sessions that loaded /search.
 *   search_click  a visitor clicked a product or collection from the dropdown or from the results page, with the query,
 *                 the product handle and its position.
 *
 * Every event carries `variant` = the visitor's ts-search A/B arm when a test is running (the split test was ended 16 Oct 2026, everyone is on Typesense, so this reads 'none').
 * Fail-safe: everything is wrapped in try/catch and never touches the page. Queries that look like personal data
 * (an @ sign or a long digit run) are never sent.
 */
(function () {
  'use strict';
  try {
    var ENDPOINT = 'https://track.jaqueslondon.co.uk/track';
    var INGEST_KEY = 'daae91a6d2b933d669e4370ff6ff077b09c5e2e397a9a5e9be0e12a8688e1f79';

    function vid() {
      // 15 Oct 2026: Shopify stopped setting _shopify_y; the Web Pixel client id now lives in shopify_client_id. Read it first (same as jjs-cart-tracker).
      try { var c = document.cookie.match(/(?:^|; )shopify_client_id=([^;]+)/); if (c) return decodeURIComponent(c[1]); } catch (e) {}
      try { var m = document.cookie.match(/_shopify_y=([^;]+)/); if (m) return decodeURIComponent(m[1]); } catch (e) {}
      try {
        var a = localStorage.getItem('jjs_aid');
        if (!a) { a = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now() + Math.random()); localStorage.setItem('jjs_aid', a); }
        return a;
      } catch (e) { return 'unknown'; }
    }
    var VID = vid();

    function variant() {
      try { return (window.JJSAB && JJSAB.variant && JJSAB.variant['ts-search']) || 'none'; } catch (e) { return 'none'; }
    }
    function clean(q) {
      q = String(q || '').replace(/\s+/g, ' ').trim().toLowerCase().slice(0, 80);
      if (q.length < 3 || /@/.test(q) || /\d{6,}/.test(q)) return '';
      return q;
    }
    function send(type, extra) {
      try {
        var body = {
          event_type: type,
          event_id: type + '-' + ((window.crypto && crypto.randomUUID) ? crypto.randomUUID() : Date.now() + '' + Math.random()),
          session_id: VID, anonymous_id: VID,
          page_url: location.href, page_path: location.pathname, referrer: document.referrer,
          variant: variant(), test_id: 'ts-search'
        };
        for (var k in extra) body[k] = extra[k];
        fetch(ENDPOINT, {
          method: 'POST', keepalive: true,
          headers: { 'Content-Type': 'application/json', 'x-jjs-key': INGEST_KEY },
          body: JSON.stringify(body)
        }).catch(function () {});
      } catch (e) {}
    }

    function isSearchBox(el) {
      return !!el && el.tagName === 'INPUT' && (el.id === 'Search' || (el.type === 'search' && el.name === 'q'));
    }
    function currentQuery() {
      var el = document.getElementById('Search');
      var q = el ? el.value : '';
      if (!q) { try { q = new URLSearchParams(location.search).get('q') || ''; } catch (e) {} }
      return clean(q);
    }

    // search_used: debounced, one event per distinct settled query
    var timer = null, lastSent = '';
    document.addEventListener('input', function (ev) {
      try {
        if (!isSearchBox(ev.target)) return;
        var el = ev.target;
        clearTimeout(timer);
        timer = setTimeout(function () {
          var q = clean(el.value);
          if (!q || q === lastSent) return;
          lastSent = q;
          send('search_used', { q: q, surface: 'dropdown' });
        }, 1000);
      } catch (e) {}
    }, true);

    // search_click: product or collection clicked from the dropdown or the results page
    document.addEventListener('click', function (ev) {
      try {
        var a = ev.target && ev.target.closest ? ev.target.closest('a') : null;
        if (!a) return;
        var href = a.getAttribute('href') || '';
        var surface = null, scope = null;
        if ((scope = a.closest('#search-suggest'))) surface = 'dropdown';
        else if ((scope = a.closest('#jjs-ts-results'))) surface = 'results_ts';
        else if (location.pathname.replace(/\/+$/, '') === '/search' && (scope = a.closest('#product-grid'))) surface = 'results_native';
        if (!surface) return;
        var m = href.match(/\/products\/([^/?#]+)/);
        var c = href.match(/\/collections\/([^/?#]+)/);
        var q = currentQuery();
        var pos = null;
        try {
          var items = scope.querySelectorAll(surface === 'dropdown' ? '.results a[href*="/products/"]' : '.product-item .image a, .product-item > .wrap a.title');
          var seen = {}, idx = 0;
          for (var i = 0; i < items.length; i++) {
            var h = (items[i].getAttribute('href') || '');
            if (seen[h]) continue; seen[h] = 1; idx++;
            if (items[i] === a || h === href) { pos = idx; break; }
          }
        } catch (e) {}
        var quick = !!(a.classList && a.classList.contains('quick-add'));
        if (m) send('search_click', { q: q, surface: surface, target: 'product', handle: decodeURIComponent(m[1]), position: pos, action: quick ? 'quick_add' : 'open' });
        else if (c) send('search_click', { q: q, surface: surface, target: 'collection', handle: decodeURIComponent(c[1]), position: pos });
        else if (quick) send('search_click', { q: q, surface: surface, target: 'product', handle: a.getAttribute('data-handle') || '', position: pos, action: 'quick_add' });
      } catch (e) {}
    }, true);
  } catch (e) { /* tracking must never break the page */ }
})();
